import React, { useState, useEffect } from 'react';
import { getImageProps } from 'app/utilities/ImageProps';
import { setSelectedPackage } from '../SalePackagesBlock/salePackagesBlockSlice';
import { packageResponse } from '../../../utilities/SalePackagesHelper';
import { connect } from 'react-redux';
import './BannerHomePage.scss';
import CarouselMobile from './CarouselMobile';
import AccordionDesktop from './AccordionDesktop';
import PaginationCircle from './PaginationCircle';
import { prepareUrl } from '../../../utilities/StringHelpers/StringHelpers.js';
import { gtag4, switchExtraction, gaEvent } from '../../../utilities/analytics/tracking';


// A wrapper for all the banner and pagination elements for mobile mode
const BannerHomePage = (props) => {
  const { iContent, context, setSelectedPackage } = props; //from EPI
  const automaticTransition = Math.abs(iContent?.automaticTransition?.value); //Transition frequency in seconds between banner elements automatically only POSITIVE
  let indexBannerOpen = Math.abs(iContent?.indexBannerOpen?.value); // Which item from the banner will be open by default, the number only POSITIVE
  if (indexBannerOpen >= iContent.items.expandedValue.length) {  // Conditions to change depending on receiving the information from EPI
    indexBannerOpen = 0;
  }
  const [activeIndex, setActiveIndex] = useState(indexBannerOpen); // Which item open by default
  const [isActiveIntervalAutoOpenBanner, setIsActiveIntervalAutoOpenBanner] = useState(true);

  // All data from EPI
  const itemsArray = iContent?.items?.expandedValue.map((item) => {
    const priTitle = item?.priTitle?.value;
    const secTitle = item?.secTitle?.value;
    const textBanner = item?.textBanner?.value;
    const linkButton = item?.linkButton?.value;
    const buttonText = item?.buttonText?.value;
    const buttonColor = item?.buttonColor?.value;
    const linkTitle = item?.linkTitle?.value;
    const isWhiteText = item?.whiteColoredTitle?.value;
    const selectedPackage = item?.salePackage?.expandedValue;
    const backgroundColor = item?.backgroundColor?.value;
    const imageBanner = getImageProps(item.imageBanner, context);
    const imageMobile = getImageProps(item.imageMobile, context);
    const titleBannerClose = item?.titleBannerClose?.value;
    const indexBannerOpen = item?.indexBannerOpen?.value;
    const textBannerMobile = item?.textBannerMobile?.value;
    const secTitleMobile = item?.secTitleMobile?.value;
    const priTitleMobile = item?.priTitleMobile?.value;
    const linkBanner= item?.linkBanner?.value;
    const isBannerClickable = !!item?.isBannerClickable?.value;

    return {
      priTitle,
      secTitle,
      textBanner,
      linkButton,
      buttonText,
      buttonColor,
      linkTitle,
      isWhiteText,
      selectedPackage,
      backgroundColor,
      imageBanner,
      imageMobile,
      titleBannerClose,
      indexBannerOpen,
      textBannerMobile,
      secTitleMobile,
      priTitleMobile,
      linkBanner,
      isBannerClickable
    };
  });

  //Google analytic- Following up on the events
  const gAupDateEvent = (params) => {
    gaEvent(
      params.category,
      params.eventType,
      params.status
    );
  };

  // Go to the page with the selected package in EPI
  const buttonOnBanner = (arrayItem, i) => {
    gAupDateEvent({ category: arrayItem?.titleBannerClose, eventType: arrayItem?.priTitle, status: arrayItem?.secTitle }) //Google analytic
    gtag4({ // Google analytic 4
      event:'HomepageCarousel_BannerClick',
      category: arrayItem?.titleBannerClose,
      section: 'HomepageCarousel',
      button: arrayItem?.buttonText,
      title: switchExtraction(arrayItem?.priTitle,arrayItem?.priTitleMobile),
      content: switchExtraction(arrayItem?.secTitle, arrayItem?.secTitleMobile),
      place: i,
    });
    const urlPage = arrayItem.linkButton;
    if (arrayItem.selectedPackage != null) {
      const selectedPackage = arrayItem.selectedPackage[0];
      const packageResponseObj = packageResponse(selectedPackage);
      setSelectedPackage(packageResponseObj);
    }
    if (urlPage) {
      prepareUrl(urlPage, props.context);
    };
  };

  // Text of the button in the banner
  const setButtonTextByIndexId = (index) => {
    if (iContent.items?.expandedValue != null &&
      iContent.items?.expandedValue.length > 0 &&
      iContent.items?.expandedValue[index] != null
    ) {
      if (itemsArray[index].buttonText != null) {
        return itemsArray[index].buttonText;
      };
    };
  };

  // The color of the button in the banner
  const getButtonClassByName = (index) => {
    let className = 'button-design';
    if (iContent.items?.expandedValue != null &&
      iContent.items?.expandedValue.length > 0 &&
      iContent.items?.expandedValue[index] != null
    ) {
      if (itemsArray[index].buttonColor != null) {
        switch (itemsArray[index].buttonColor) {
          case 1:
            className = `${className} link-purple`;
            break;
          case 2:
              className = `${className} link-black`;
              break;
          case 3:
              className = `${className} link-white`;
              break;
          };
        return className;
      };
    }
  };

  // Any change in both variables will re-render the banner item
  useEffect(() => {
    let interval;
    if (isActiveIntervalAutoOpenBanner) {
      interval = setInterval(() => {
        setActiveIndex((activeIndex + 1) % iContent.items.expandedValue.length); /*Makes progress in the array (one index at a time) in a circular manner according to the length of the array
          according to the balance in the meter */
      }, automaticTransition);

    } else {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [activeIndex, isActiveIntervalAutoOpenBanner]);

  return (
    <section className='accordion-and-carousel'>
      <div className='mobile-carousel'>
        <ul style={{ marginRight: -(activeIndex * 100) + "%" }}> {/*style for Carousel In order to have a transition between the seals */}
          {itemsArray?.map((item, index) =>
            <CarouselMobile
              key={index}
              i={index}
              activeIndex={activeIndex}
              setActiveIndex={setActiveIndex}
              iContent={iContent}
              item={item}
              buttonOnBanner={buttonOnBanner}
              automaticTransition={automaticTransition}
              isActiveIntervalAutoOpenBanner={isActiveIntervalAutoOpenBanner}
              setIsActiveIntervalAutoOpenBanner={setIsActiveIntervalAutoOpenBanner}
              indexBannerOpen={indexBannerOpen}
              setButtonTextByIndexId={setButtonTextByIndexId}
              getButtonClassByName={getButtonClassByName}
              context={context}
            />
          )}
        </ul>
        <div className='container-pagination-circle'>
          {itemsArray.length > 1 && itemsArray?.map((item, index) =>
            <PaginationCircle
              key={index}
              i={index}
              setActiveIndex={setActiveIndex}
              activeIndex={activeIndex}
              setIsActiveIntervalAutoOpenBanner={setIsActiveIntervalAutoOpenBanner}
              gAupDateEvent={gAupDateEvent}
              gtag4={gtag4}
              item={item}
              switchExtraction={switchExtraction}
            />
          )}
        </div>
      </div>
      <div className='container-desktop-accordion'>
        <div className='desktop-accordion'>
          <ul>
            {itemsArray?.map((item, index) =>
              <AccordionDesktop
                key={index}
                i={index}
                activeIndex={activeIndex}
                setActiveIndex={setActiveIndex}
                item={item}
                buttonOnBanner={buttonOnBanner}
                automaticTransition={automaticTransition}
                isActiveIntervalAutoOpenBanner={isActiveIntervalAutoOpenBanner}
                setIsActiveIntervalAutoOpenBanner={setIsActiveIntervalAutoOpenBanner}
                indexBannerOpen={indexBannerOpen}
                setButtonTextByIndexId={setButtonTextByIndexId}
                getButtonClassByName={getButtonClassByName}
                gtag4={gtag4}
                switchExtraction={switchExtraction}
                context={context}
              />
            )}
          </ul>
        </div>
      </div>
    </section>
  )
}

const mapStateToProps = (state) => {
  return {
    selectedPackage: state.SalePackagesBlock?.selectedPackage,
  };
};

const mapDispatchToProps = { setSelectedPackage };

export default connect(mapStateToProps, mapDispatchToProps)(BannerHomePage);

